import { CircularProgressbar } from 'react-circular-progressbar';

import useEvent from '@lyearn/core/hooks/useEvent';
import { CloseOutline } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { Box, IconButton, Stack } from '@lyearn/ui';

import * as Media from '../../MediaEntity';
import { circularProgress } from '../styles';
import { MediaItemWithRemoveActionProps } from '../types';

const MEDIA_ICON_CLASSES = {
  icon: 'h-40 w-32 flex-shrink-0',
  image: 'h-40 w-40 flex-shrink-0 rounded-6',
};

const DefaultMediaItem = (props: MediaItemWithRemoveActionProps) => {
  const { className, media, onClick, onRemove } = props;
  const progress = media.progress;

  const onClickHandler = useEvent(() => {
    onClick?.(media);
  });

  const onRemoveHandler = useEvent(() => {
    onRemove?.(media, media.attachmentEntityInfo);
  });

  return (
    <Media.Provider
      className={cn(
        'group relative cursor-pointer overflow-visible rounded border border-border bg-bg-primary p-12 pe-24 hover:bg-bg-hover-light active:bg-bg-onclick',
        className,
      )}
      media={media}>
      <Stack alignItems="center" className="truncate" gap={12} onClick={onClickHandler}>
        <Media.Icon classes={MEDIA_ICON_CLASSES} />
        <Stack className="truncate" direction="col" gap={2}>
          <Media.Name showFileExtension={false} />
          <Media.Description />
        </Stack>
      </Stack>
      {onRemove ? (
        progress ? (
          <Box
            className={cn(
              'absolute -top-8 h-20 w-20 rounded-full border border-border bg-bg-primary p-4 opacity-100 -end-8 hover:border-border-medium',
              circularProgress,
            )}>
            <CircularProgressbar className="fill-current" strokeWidth={16} value={progress} />
          </Box>
        ) : (
          <IconButton
            Icon={CloseOutline}
            className="bg-primary absolute -top-8 items-start gap-10 p-4 opacity-0 -end-8 group-hover:opacity-100"
            size="xxs"
            variant="outlined"
            onClick={onRemoveHandler}
          />
        )
      ) : null}
    </Media.Provider>
  );
};

export default DefaultMediaItem;
